export const getHost = () => {
    // 获取当前二级域名，如果获取不到，则返回www
    const hostname = window.location.host
    const parts = hostname.split('.')
    let host = 'www'
    if (parts.length >= 3) {
        host = parts[0]
    }
    // 将二级域名持久化到本地存储
    try {
      localStorage.setItem('host', host)
    } catch (e) {
    }
    return host
  }
